import { ComponentNames } from "../../constant/component-constant";
import { sortGenrepack } from "../../helper/genre-helper";
import { logAdapterEvent, logError } from "../../helper/logger";
import { addPackageDetailsToEmbeddedSvods } from "../../helper/svod-utils";
import { pickChannels } from "../../helper/channels-service-helpers";

const ADAPTER_NAME = "inpagechannelPackLineupAdapeter";

interface IInpageChannelPackLineupAdapter {
  content: any;
  channelListingData: any;
  channelsServiceData?: any;
  svodGenreData: any;
  genreLocalChannelMapping: any;
  signatureExcludedLocalChannels?: any[];
  packageConfig: any;
  myFreeDTVConfig: any;
  genreNationals: any;
  cmsPageName?: string;
  embeddedSvods?: any;
  dtviEmbeddedIncludedSvods?: any;
  dtvsEmbeddedIncludedSvods?: any;
  genreSvodOffers?: any;
}

const getMatchingKeys = (keyMatch): string[] => {
  const result: string[] = [];

  keyMatch.forEach(key => {
    result.push(key)
  })

  return result;
};

export const inpagechannelPackLineupAdapeter = ({
  content,
  channelListingData,
  channelsServiceData,
  svodGenreData,
  genreLocalChannelMapping,
  signatureExcludedLocalChannels,
  packageConfig,
  myFreeDTVConfig: _myFreeDTVConfig,
  genreNationals,
  cmsPageName,
  embeddedSvods,
  dtviEmbeddedIncludedSvods,
  dtvsEmbeddedIncludedSvods,
  genreSvodOffers
}: IInpageChannelPackLineupAdapter): any => {
  try {
    logAdapterEvent(ADAPTER_NAME, "Adapter execution started", {
      cmsPageName
    });

    const channels =
      pickChannels(
        channelsServiceData?.channels,
        channelListingData?.[":items"]?.chnlListingPageData?.elements?.channels
      );

    let availableChannels = [];
    if (content?.channelTypes && content?.channelTypes.length > 0) {
      const channeltypes = getMatchingKeys(content.channelTypes);
      availableChannels = channels.filter(chl => chl.packageListSystem?.some(item => channeltypes.includes(item)));
    }
    content.packages = sortGenrepack(
      content?.packages,
      packageConfig,
      "channelpacklineup"
    );
    const embeddedSvodIcons: Record<string, any[]> = {};
    // Generated by Copilot- Start
    (content?.channelTypes || []).forEach(pkgId => {
      const config = packageConfig.find((pkg: any) => pkg.id === pkgId);
      const pkgType = config?.type;
      if (config) {
        const inPageChlupData = addPackageDetailsToEmbeddedSvods({
          embeddedSvods,
          epochSvodsData: pkgType === 'genre' ? svodGenreData : (pkgType === 'internet' ? dtviEmbeddedIncludedSvods : dtvsEmbeddedIncludedSvods),
          packageConfig,
          componentType: ComponentNames.INPAGECHANNELPACKLINEUP,
          svodMapping: pkgType === 'genre' ? genreSvodOffers?.svodMapping : '',
          isSatellite: pkgType === 'satellite',
          pkgId,
          pkgType
        });
        embeddedSvodIcons[pkgId] = inPageChlupData;
      }
    });
    // Remove duplicates in case of multiple packages has same svod
    const uniqueSvodsMap = new Map();
    const allSvods = Object.values(embeddedSvodIcons).flat();
    for (const svod of allSvods) {
      if (!uniqueSvodsMap.has(svod.name)) {
        uniqueSvodsMap.set(svod.name, svod);
      }
    }
    const uniqueSvods = Array.from(uniqueSvodsMap.values());
    // Generated by Copilot- End
    return {
      props: {
        ...content,
        svodGenreData,
        genreLocalChannelMapping,
        signatureExcludedLocalChannels,
        genreNationals,
        availableChannels,
        embeddedSvodIcons: uniqueSvods
      },
      type: ComponentNames.INPAGECHANNELPACKLINEUP
    };
  } catch (error) {
    logError(ADAPTER_NAME, error, {
      cmsPageName
    });
  }
};

export default inpagechannelPackLineupAdapeter;
